export default {
  'nav.home': '首页',
  'nav.about': '公司简介',
  'nav.advantages': '核心优势',
  'nav.products': '产品体系',
  'nav.products.overview': '产品总览',
  'nav.products.cex': '中心化交易所',
  'nav.products.rwa': 'RWA 解决方案',
  'nav.products.wallet': '钱包类产品',
  'nav.products.staking': '质押类产品',
  'nav.products.mining': '挖矿类产品',
  'nav.services': '服务',
  'nav.services.overview': '服务总览',
  'nav.services.overseasFund': '海外基金设立',
  'nav.services.financialLicensing': '金融牌照申请',
  'nav.services.overseasCompany': '海外公司设立',
  'nav.services.mergersAcquisitions': '公司并购',
  'nav.news': '新闻动态',
  'nav.contact': '联系我们',
  'nav.cta': '立即咨询',

  'hero.tag': '产业区块链 & Web3 全栈解决方案',
  'hero.title1': '赋能企业 Web3 转型',
  'hero.title2': '构建可信数字未来',
  'hero.subtitle': '新加坡总部 · 模块化架构 · 技术即服务',
  'hero.cta1': '探索解决方案',
  'hero.cta2': '查看产品体系',

  'stats.years': '8+',
  'stats.years.label': '年安全服务经验',
  'stats.clients': '50+',
  'stats.clients.label': '企业合作客户',
  'stats.projects': '200+',
  'stats.projects.label': '项目成功交付',
  'stats.support': '24/7',
  'stats.support.label': '全天候技术支持',

  'about.tag': '公司简介',
  'about.title': '新加坡总部 · 全球服务',
  'about.desc1': '我们是一家总部位于新加坡的产业区块链与 Web3 创新科技服务公司，专注于为企业提供全栈区块链解决方案。',
  'about.desc2': '团队由资深区块链专家、工程师和 Web3 顾问组成，秉持"技术即服务"的核心理念，致力于推动实体经济与 Web3 的深度融合。',
  'about.desc3': '产品体系涵盖中心化交易所、RWA 资产代币化、去中心化钱包、DApp 定制开发等核心领域，提供从咨询、开发到运维的全生命周期服务。',
  'about.badge': '新加坡注册',
  'about.badge2': '2023 年成立',
  'about.more': '了解更多',

  'services.tag': '核心服务',
  'services.title': '四大核心服务领域',
  'services.cex.title': '中心化交易所 CEX',
  'services.cex.desc': '全栈 CEX 系统开发，订单撮合引擎、KYC/AML 合规、多端支持，弹性扩容至百万 TPS。',
  'services.cex.f1': '高性能撮合引擎',
  'services.cex.f2': 'KYC/AML 合规',
  'services.cex.f3': '多端 PC/H5',
  'services.wallet.title': '钱包 + IM 系统',
  'services.wallet.desc': '多链去中心化钱包与社交 IM 融合，支持 DApp 浏览器、NFT 管理与 DAO 治理。',
  'services.wallet.f1': '多链资产管理',
  'services.wallet.f2': 'DApp 浏览器',
  'services.wallet.f3': 'NFT 市场',
  'services.rwa.title': 'RWA 资产代币化',
  'services.rwa.desc': '将房地产、艺术品、供应链等实物资产上链，实现合规确权、智能合约分红与全球流通。',
  'services.rwa.f1': '法律合规确权',
  'services.rwa.f2': '智能合约分红',
  'services.rwa.f3': '全球合格投资者',
  'services.dapp.title': 'DApp 定制开发',
  'services.dapp.desc': '质押、流动性挖矿、GameFi、私募、社交等全链路 DApp 定制化开发。',
  'services.dapp.f1': '质押 / 挖矿',
  'services.dapp.f2': 'GameFi / NFT',
  'services.dapp.f3': '私募 / 分红',
  'services.more': '查看详情',

  'adv.tag': '核心优势',
  'adv.title': '为什么选择我们',
  'adv.subtitle': '8 年+行业深耕，以技术驱动，护航您的 Web3 业务',
  'adv.1.num': '01',
  'adv.1.title': '模块化架构',
  'adv.1.desc': '高度模块化的系统设计，各功能模块独立部署、自由组合，支持快速迭代与灵活扩展，大幅降低业务升级成本。',
  'adv.2.num': '02',
  'adv.2.title': '完整公链生态布局',
  'adv.2.desc': '深度支持以太坊、BSC、Solana、波场等主流公链，具备完整的跨链互操作能力，构建多链并行的产品矩阵。',
  'adv.3.num': '03',
  'adv.3.title': '创新驱动',
  'adv.3.desc': '持续跟踪 Web3 前沿技术，将 ZK Proof、Layer2、AI 风控等创新能力融入产品，始终保持技术领先地位。',
  'adv.4.num': '04',
  'adv.4.title': '安全合规',
  'adv.4.desc': '多重安全审计体系，符合新加坡 MAS、香港 SFC 等主流司法辖区合规要求，为客户提供全方位可信保障。',
  'adv.5.num': '05',
  'adv.5.title': '客户导向与生态共赢',
  'adv.5.desc': '专属项目经理、24/7 技术支持、生态资源对接，以客户业务成功为最终目标，携手共建 Web3 生态。',

  'products.tag': '产品体系',
  'products.title': '完整产品矩阵',
  'products.subtitle': '从咨询、开发到运维，提供全生命周期一站式支持',
  'products.exchange': '交易所系统',
  'products.rwa': 'RWA 解决方案',
  'products.wallet': '钱包类产品',
  'products.staking': '质押类产品',
  'products.mining': '挖矿类产品',
  'products.more': '查看详情',

  'news.tag': '新闻动态',
  'news.title': '最新资讯',
  'news.subtitle': '产品迭代 · 行业洞察 · Web3 前沿',
  'news.more': '查看全部',
  'news.read': '阅读更多',
  'news.product': '产品动态',
  'news.industry': '行业动态',

  'cta.title': '准备开启您的 Web3 之旅？',
  'cta.subtitle': '专业团队一对一咨询，从战略规划到技术落地全程陪伴',
  'cta.btn': '立即联系我们',
  'cta.btn2': '查看产品案例',
  'cta.badge1': '新加坡注册企业',
  'cta.badge2': '8 年+经验',
  'cta.badge3': '24/7 支持',
  'cta.badge4': '源码交付',

  'footer.about': '总部位于新加坡的产业区块链与 Web3 全栈解决方案服务商，专注为企业构建可信数字基础设施。',
  'footer.links': '快速链接',
  'footer.products': '产品体系',
  'footer.services': '专业服务',
  'footer.contact': '联系我们',
  'footer.address': '160 Robinson Road, #14-04 SBFCenter, Singapore 068914',
  'footer.email': 'info@geelx.com',
  'footer.telegram': 'Telegram: +447849923593',
  'footer.whatsapp': 'WhatsApp: +447849923593',
  'footer.copyright': '© 2026 Geelx.com. All rights reserved.',
  'footer.privacy': '隐私政策',
  'footer.terms': '服务条款',
  'footer.subscribe': '订阅行业资讯',
  'footer.subscribe.placeholder': '输入您的邮箱',
  'footer.subscribe.btn': '订阅',
  'footer.subscribe.success': '订阅成功！感谢您的关注',
  'footer.rss': 'RSS 订阅新闻',
  'rss.feedTitle': 'Geelx 新闻动态',
  'rss.subscribe': 'RSS 订阅',
  'footer.wechat': '微信：请扫描二维码',
  'footer.badge.security': '安全认证',
  'footer.badge.singapore': '新加坡注册',
  'footer.badge.experience': '8年+ 经验',
  'footer.badge.support': '24/7 支持',

  'breadcrumb.home': '首页',
  'breadcrumb.about': '公司简介',
  'notFound.title': '页面不存在',
  'notFound.subtitle': '请检查链接是否正确，或返回首页继续浏览。',

  'aboutPage.hero.tag': 'About Us',
  'aboutPage.hero.title': '公司简介',
  'aboutPage.hero.highlight': '我们是谁',
  'aboutPage.hero.subtitle1': '总部位于新加坡的产业区块链与 Web3 全栈解决方案服务商。',
  'aboutPage.hero.subtitle2': '我们将复杂的区块链技术转化为企业可落地的生产力，推动实体经济与 Web3 深度融合。',
  'aboutPage.hero.stats.0.val': '2023',
  'aboutPage.hero.stats.0.label': '年成立',
  'aboutPage.hero.stats.1.val': '新加坡',
  'aboutPage.hero.stats.1.label': '总部所在地',
  'aboutPage.hero.stats.2.val': '8+',
  'aboutPage.hero.stats.2.label': '年行业经验',
  'aboutPage.hero.stats.3.val': '50+',
  'aboutPage.hero.stats.3.label': '企业客户',
  'breadcrumb.news': '新闻动态',
  'newsPage.categories.all': '全部动态',
  'newsPage.categories.product': '产品动态',
  'newsPage.categories.industry': '行业动态',
  'newsPage.hero.tag': 'News & Insights',
  'newsPage.hero.title': '新闻动态',
  'newsPage.hero.highlight': '洞察 Web3 前沿',
  'newsPage.hero.desc1': '产品动态、技术深度解析、行业趋势洞察——',
  'newsPage.hero.desc2': '我们持续为您带来 Web3 与产业区块链领域最新资讯。',
  'newsPage.hero.stats.articles': '篇文章',
  'newsPage.hero.stats.categories': '内容分类',
  'newsPage.hero.stats.frequency': '月更',
  'newsPage.hero.stats.monthly': '12+ 篇',
  'newsPage.featured.title': '精选文章',
  'newsPage.featured.badge': '精选',
  'newsPage.readSuffix': '阅读',
  'newsPage.readFull': '阅读全文',
  'newsPage.grid.empty': '暂无该分类的文章',
  'newsPage.grid.total': '共 {{count}} 篇',
  'newsPage.grid.loadMore': '加载更多文章（剩余 {{remaining}} 篇）',
  'newsPage.grid.allShown': '已显示全部 {{count}} 篇文章',
  'newsDetail.readTime': '预计阅读 {{time}}',
  'newsDetail.share': '分享：',
  'newsDetail.related.title': '相关文章',
  'newsDetail.summary': '文章概要',
  'newsDetail.contactHint': '有业务需求？与我们的专家沟通',
  'newsDetail.contactTeam': '联系商务团队',
  'newsDetail.shareArticle': '分享文章',
  'newsDetail.copyLink': '复制链接',
  'share.linkCopied': '链接已复制',
  'share.native': '更多分享方式',
  'newsDetail.cta.subtitle': '想了解更多 Web3 解决方案？',
  'newsDetail.cta.title': '联系我们的专业团队，获取定制化方案',
  'newsDetail.backToList': '返回列表',
  'breadcrumb.contact': '联系我们',
  'contact.hero.tag': 'Contact Us',
  'contact.hero.title': '联系我们',
  'contact.hero.highlight': '开启合作对话',
  'contact.hero.desc1': '无论您是初创项目还是成熟企业，我们的团队随时准备为您提供专业的 Web3 解决方案咨询服务。',
  'contact.hero.desc2': '填写表单或直接联系我们，通常 24 小时内回复。',
  'contact.hero.card.0.label': '邮件咨询',
  'contact.hero.card.0.val': 'info@geelx.com',
  'contact.hero.card.1.label': '7×24 在线支持',
  'contact.hero.card.1.val': '随时响应',
  'contact.hero.card.2.label': '平均响应时间',
  'contact.hero.card.2.val': '< 4 小时',
  'contact.form.captcha': '验证码',
  'contact.form.captcha.placeholder': '请输入验证码',
  'contact.form.captcha.refresh': '换一张',
  'contact.form.error.captcha': '验证码错误或已过期，请重新输入',
  'contact.form.error.maxChars': '留言内容不能超过 500 字符',
  'contact.form.success.title': '提交成功！',
  'contact.form.success.desc1': '感谢您的留言，我们的商务团队将在',
  'contact.form.success.descStrong': '24 小时内',
  'contact.form.success.desc2': '与您取得联系。',
  'contact.form.success.desc3': '请留意来自',
  'contact.form.success.desc4': '的邮件。',
  'contact.form.submitAgain': '再次提交',
  'contact.form.title': '发送咨询',
  'contact.form.subtitle': '请填写以下信息，我们将尽快与您联系',
  'contact.form.name': '姓名',
  'contact.form.name.placeholder': '您的姓名',
  'contact.form.company': '公司名称',
  'contact.form.company.placeholder': '您的公司（选填）',
  'contact.form.email': '邮件地址',
  'contact.form.phone': '电话 / WhatsApp',
  'contact.form.inquiryType': '咨询业务',
  'contact.form.inquiryType.placeholder': '请选择咨询类型...',
  'contact.form.budget': '预算范围',
  'contact.form.message': '留言内容',
  'contact.form.message.placeholder': '请简要描述您的项目需求、当前阶段及期望时间线...',
  'contact.form.message.hint': '详细的描述将帮助我们更快匹配方案',
  'contact.form.error.submitFailed': '提交失败，请稍后重试或直接发送邮件联系我们',
  'contact.form.submitting': '提交中...',
  'contact.form.submit': '发送咨询',
  'contact.form.agreePrefix': '提交即表示您同意我们的',
  'contact.form.and': '及',
  'contact.social': '社交媒体',
  'contact.social.wechat': '微信公众号',
  'contact.offices.tag': 'Global Offices',
  'contact.offices.title': '全球办公室布局',
  'contact.offices.subtitle': '三地协同运营，确保跨时区快速响应，本地化服务全球客户',
  'contact.faq.tag': 'FAQ',
  'contact.faq.title': '常见问题',
  'contact.faq.highlight': '快速解答',
  'contact.faq.subtitle': '以下是客户在合作初期最常询问的问题。如果您有其他疑问，欢迎直接提交表单联系我们。',
  'contact.faq.notFound': '没找到答案？',
  'contact.faq.askExpert': '直接咨询我们的专家',
  'contact.faq.submitForm': '提交咨询表单',
  'contact.bottom.title': '准备好开始您的 Web3 项目了吗？',
  'contact.bottom.subtitle': '立即联系我们，获取免费的项目评估报告与技术方案建议',
  'contact.bottom.emailUs': '发邮件给我们',
  'contact.bottom.submitNow': '立即提交咨询',
  'contact.inquiry.0': '中心化交易所 (CEX) 开发',
  'contact.inquiry.1': 'RWA 资产代币化',
  'contact.inquiry.2': 'Web3 钱包开发',
  'contact.inquiry.3': 'DeFi 质押协议',
  'contact.inquiry.4': '矿机托管平台',
  'contact.inquiry.5': '智能合约审计',
  'contact.inquiry.6': '企业区块链定制',
  'contact.inquiry.7': '其他咨询',
  'contact.info.address': '总部地址',
  'contact.info.email': '商务邮件',
  'contact.info.email.partner': '合作伙伴: partner@geelx.com',
  'contact.info.email.market': '市场: market@geelx.com',
  'contact.info.phone': 'Telegram/WhatsApp',
  'contact.info.telegram': 'Telegram: +44 7849923593',
  'contact.info.whatsapp': 'WhatsApp: +44 7849923593',
  'contact.info.hours': '工作时间',
  'contact.info.hours.line1': '周一至周五 09:00 – 18:00 SGT',
  'contact.info.hours.line2': '技术支持 7 × 24 小时',
  'contact.office.0.city': '新加坡（总部）',
  'contact.office.1.city': '香港（业务中心）',
  'contact.office.2.city': '上海（研发协作）',
  'contact.office.2.address': '上海市浦东新区陆家嘴金融区某大厦 18F',
  'contact.faq.items.0.q': '从提交需求到正式立项需要多久？',
  'contact.faq.items.0.a': '通常在初次沟通后 3–5 个工作日内完成需求评估，并向您提交初步解决方案与报价。正式签约后即可启动项目。',
  'contact.faq.items.1.q': '你们支持哪些合作模式？',
  'contact.faq.items.1.a': '我们提供固定报价项目制、按月技术外包、战略技术合伙三种模式，可根据您的阶段和预算灵活组合。',
  'contact.faq.items.2.q': '是否提供源代码交付？',
  'contact.faq.items.2.a': '是的，所有项目均包含完整源代码交付（含开发文档与部署手册）。我们绝不保留后门或绑定依赖。',
  'contact.faq.items.3.q': '能否协助申请监管牌照？',
  'contact.faq.items.3.a': '我们与新加坡 MAS、香港 SFC 等主流辖区持牌律所保持深度合作，可为您的项目提供合规架构设计和牌照申请引导服务。',
  'contact.faq.items.4.q': '项目完成后是否有售后支持？',
  'contact.faq.items.4.a': '标准服务包含交付后 3 个月免费维护期，含 24/7 线上支持与 Bug 修复。此后可签订年度运维协议。',
  'contact.faq.items.5.q': '是否接受海外客户远程合作？',
  'contact.faq.items.5.a': '完全支持。我们 60% 以上的客户来自海外，使用 Zoom / Slack / Notion 进行高效远程协作，时区无障碍。',
  'breadcrumb.products': '产品体系',
  'breadcrumb.services': '服务',

  'serviceDetail.outline': '内容概要',
  'serviceDetail.contactHint': '有业务需求？与我们的专家沟通',
  'serviceDetail.contactTeam': '联系商务团队',
  'serviceDetail.cta.subtitle': '准备好开始了吗？',
  'serviceDetail.cta.title': '立即与我们的专家联系，探讨您的需求',
  'serviceDetail.backToList': '返回服务列表',
  'productsPage.hero.tag': 'Product Suite',
  'productsPage.hero.title': '产品体系',
  'productsPage.hero.highlight': '全栈 Web3 解决方案',
  'productsPage.hero.desc1': '五大产品线覆盖交易所、资产管理、去中心化钱包、质押与挖矿全场景，',
  'productsPage.hero.desc2': '提供从咨询规划到开发交付再到持续运维的全生命周期服务。',
  'productsPage.hero.chip.cex': '中心化交易所',
  'productsPage.hero.chip.rwa': 'RWA 解决方案',
  'productsPage.hero.chip.wallet': '钱包生态',
  'productsPage.hero.chip.defi': 'DeFi 质押',
  'productsPage.hero.chip.mining': '挖矿平台',
  'productsOverview.tag': 'Product Lines',
  'productsOverview.title': '四大核心产品线',
  'productsOverview.desc1': '从交易基础设施到资产管理，覆盖 Web3 企业全场景需求，',
  'productsOverview.desc2': '全生命周期服务：咨询 -> 开发 -> 运维',
  'productsOverview.cta': '查看详细方案',
  'productsOverview.lines.cex.label': '中心化交易所 CEX',
  'productsOverview.lines.cex.desc': '全栈 CEX 解决方案，覆盖标准版、集群版、大客户定制版，支持高性能订单撮合引擎与多端覆盖。',
  'productsOverview.lines.cex.tags.0': '标准单体',
  'productsOverview.lines.cex.tags.1': '集群版',
  'productsOverview.lines.cex.tags.2': '大客户定制',
  'productsOverview.lines.cex.tags.3': 'PC / H5',
  'productsOverview.lines.cex.stats.0': 'TPS',
  'productsOverview.lines.cex.stats.1': 'SLA',
  'productsOverview.lines.wallet.label': '钱包 + IM 生态',
  'productsOverview.lines.wallet.desc': 'Web3 去中心化钱包 App、钱包+IM 社交融合、网页版全平台覆盖，80+ 条公链一站式管理。',
  'productsOverview.lines.wallet.tags.0': 'App 钱包',
  'productsOverview.lines.wallet.tags.1': '钱包+IM',
  'productsOverview.lines.wallet.tags.2': '网页版',
  'productsOverview.lines.wallet.stats.0': '条公链',
  'productsOverview.lines.wallet.stats.1': '端覆盖',
  'productsOverview.lines.rwa.label': 'RWA 资产上链',
  'productsOverview.lines.rwa.desc': '房地产、艺术品、供应链、私募股权等真实资产上链，法律合规+技术可信+金融流通三层架构。',
  'productsOverview.lines.rwa.tags.0': '房地产',
  'productsOverview.lines.rwa.tags.1': '艺术品',
  'productsOverview.lines.rwa.tags.2': '供应链',
  'productsOverview.lines.rwa.tags.3': '私募股权',
  'productsOverview.lines.rwa.stats.0': '层架构',
  'productsOverview.lines.rwa.stats.1': '司法辖区',
  'productsOverview.lines.dapp.label': 'DeFi 质押 & 云矿机',
  'productsOverview.lines.dapp.desc': '质押系统、挖矿平台、NFT 市场、游戏 DApp、私募平台等全品类定制开发，源码交付。',
  'productsOverview.lines.dapp.tags.0': '质押系统',
  'productsOverview.lines.dapp.tags.1': '挖矿平台',
  'productsOverview.lines.dapp.tags.2': 'NFT',
  'productsOverview.lines.dapp.tags.3': '游戏 DApp',
  'productsOverview.lines.dapp.stats.0': '交付',
  'productsOverview.lines.dapp.stats.1': '支持',
  'productsLifecycle.quick.title': '五大产品线，快速直达',
  'productsLifecycle.quick.subtitle': '选择您感兴趣的产品类别，查看完整技术方案',
  'productsLifecycle.tag': 'Full Lifecycle',
  'productsLifecycle.title': '全生命周期服务',
  'productsLifecycle.desc': '从初始咨询到持续运维，每个阶段都有专业团队保障，让您的 Web3 项目从想法到商业化无缝落地',
  'productsLifecycle.stepPrefix': 'STEP',
  'productsLifecycle.steps.0.title': '需求咨询',
  'productsLifecycle.steps.0.desc': '业务分析与技术选型建议，输出完整方案文档与报价',
  'productsLifecycle.steps.0.duration': '3-5 个工作日',
  'productsLifecycle.steps.1.title': '架构设计',
  'productsLifecycle.steps.1.desc': '系统架构规划、技术栈确定、UI/UX 原型评审',
  'productsLifecycle.steps.1.duration': '1-2 周',
  'productsLifecycle.steps.2.title': '开发交付',
  'productsLifecycle.steps.2.desc': '敏捷迭代开发，专属项目经理全程跟进，阶段性验收',
  'productsLifecycle.steps.2.duration': '4-16 周',
  'productsLifecycle.steps.3.title': '安全审计',
  'productsLifecycle.steps.3.desc': '智能合约审计、渗透测试、代码质量评审，确保上线安全',
  'productsLifecycle.steps.3.duration': '1-2 周',
  'productsLifecycle.steps.4.title': '上线部署',
  'productsLifecycle.steps.4.desc': '生产环境部署、压力测试、灰度发布与上线监控',
  'productsLifecycle.steps.4.duration': '3-7 天',
  'productsLifecycle.steps.5.title': '持续运维',
  'productsLifecycle.steps.5.desc': '7×24 技术支持、系统监控、版本迭代与功能升级',
  'productsLifecycle.steps.5.duration': '持续服务',
  'productsLifecycle.cta.start': '立即开始咨询',
  'productsLifecycle.cta.learn': '了解服务保障',
  'productsDetail.cex.breadcrumb': '中心化交易所',
  'productsDetail.cex.title': '中心化交易所',
  'productsDetail.cex.highlight': '全栈一站式方案',
  'productsDetail.cex.cta': '获取方案报价',
  'productsDetail.cex.desc1': '从标准单体架构到企业级集群部署，从大客户定制到 PC/H5 全端覆盖，',
  'productsDetail.cex.desc2': '提供高性能订单撮合引擎、KYC/AML 合规模块及完整运维体系，',
  'productsDetail.cex.desc3': '助您快速上线并安全规模化运营。',
  'productsDetail.cex.tags.0': '100K+ TPS 撮合',
  'productsDetail.cex.tags.1': 'KYC/AML 合规',
  'productsDetail.cex.tags.2': 'PC / H5 / APP',
  'productsDetail.cex.tags.3': '7×24 运维保障',
  'productsDetail.cex.stats.0.label': '峰值撮合性能',
  'productsDetail.cex.stats.1.label': '系统可用性保障',
  'productsDetail.cex.stats.2.label': '订单响应延迟',
  'productsDetail.cex.stats.3.unit': '家',
  'productsDetail.cex.stats.3.label': '全球成功上线案例',
  'productsDetail.cex.tabs.standard': '标准单体架构',
  'productsDetail.cex.tabs.cluster': '集群版',
  'productsDetail.cex.tabs.custom': '大客户定制版',
  'productsDetail.cex.tabs.pc': 'PC 端',
  'productsDetail.cex.tabs.h5': 'H5 移动端',
  'productsDetail.rwa.breadcrumb': 'RWA 资产代币化',
  'productsDetail.rwa.title': 'RWA 资产代币化',
  'productsDetail.rwa.highlight': '链上合规发行平台',
  'productsDetail.rwa.cta': '获取合规方案报价',
  'productsDetail.rwa.desc1': '将现实世界资产（房产、股权、债券、大宗商品）映射至区块链，',
  'productsDetail.rwa.desc2': '构建符合主流司法辖区监管要求的数字证券发行、流通与清结算全生命周期平台，',
  'productsDetail.rwa.desc3': '打通传统金融与 Web3 流动性。',
  'productsDetail.rwa.tags.0': '多辖区合规',
  'productsDetail.rwa.tags.1': 'STO 标准',
  'productsDetail.rwa.tags.2': '二级流通市场',
  'productsDetail.rwa.tags.3': '智能合约审计',
  'productsDetail.rwa.stats.0.unit': '类',
  'productsDetail.rwa.stats.0.label': '支持资产种类',
  'productsDetail.rwa.stats.1.label': '累计代币化规模',
  'productsDetail.rwa.stats.2.unit': '辖区',
  'productsDetail.rwa.stats.2.label': '合规覆盖范围',
  'productsDetail.rwa.stats.3.unit': '项目',
  'productsDetail.rwa.stats.3.label': '全球成功发行案例',
  'productsDetail.rwa.tabs.compliance': '合规框架',
  'productsDetail.rwa.tabs.architecture': '技术架构',
  'productsDetail.rwa.tabs.assetTypes': '资产类型',
  'productsDetail.rwa.tabs.issuance': '发行流程',
  'productsDetail.rwa.tabs.market': '二级市场',
  'productsDetail.wallet.breadcrumb': 'Web3 钱包',
  'productsDetail.wallet.title': 'Web3 多链钱包',
  'productsDetail.wallet.highlight': '一体化资产管理门户',
  'productsDetail.wallet.cta': '获取钱包方案',
  'productsDetail.wallet.desc1': '支持 100+ 主流公链，集 MPC 多方计算安全、DApp 内置浏览器、',
  'productsDetail.wallet.desc2': '跨链兑换与企业级资产托管于一体，',
  'productsDetail.wallet.desc3': '为 C 端用户与机构客户提供专业级 Web3 入口。',
  'productsDetail.wallet.tags.0': '100+ 公链',
  'productsDetail.wallet.tags.1': 'MPC 安全',
  'productsDetail.wallet.tags.2': 'DApp 浏览器',
  'productsDetail.wallet.tags.3': '跨链兑换',
  'productsDetail.wallet.stats.0.unit': '条',
  'productsDetail.wallet.stats.0.label': '支持公链数量',
  'productsDetail.wallet.stats.1.unit': '用户',
  'productsDetail.wallet.stats.1.label': '全球活跃用户',
  'productsDetail.wallet.stats.2.unit': '个',
  'productsDetail.wallet.stats.2.label': '集成 DApp 数量',
  'productsDetail.wallet.stats.3.unit': '次',
  'productsDetail.wallet.stats.3.label': '安全漏洞记录',
  'productsDetail.wallet.tabs.multichain': '多链支持',
  'productsDetail.wallet.tabs.security': '安全体系',
  'productsDetail.wallet.tabs.dapp': 'DApp 生态',
  'productsDetail.wallet.tabs.enterprise': '企业钱包',
  'productsDetail.wallet.tabs.sdk': '开发者 SDK',
  'productsDetail.defi.breadcrumb': 'DeFi 质押协议',
  'productsDetail.defi.title': 'DeFi 质押协议',
  'productsDetail.defi.highlight': '高收益流动性全栈方案',
  'productsDetail.defi.cta': '获取 DeFi 方案',
  'productsDetail.defi.desc1': '从 PoS 质押、AMM 流动性挖矿到收益聚合器，再到跨链桥与 DAO 治理，',
  'productsDetail.defi.desc2': '提供完整的 DeFi 协议开发与部署服务，',
  'productsDetail.defi.desc3': '让用户资产持续增值，平台流动性深度持续扩展。',
  'productsDetail.defi.tags.0': 'PoS 质押',
  'productsDetail.defi.tags.1': 'AMM 流动性',
  'productsDetail.defi.tags.2': '收益聚合',
  'productsDetail.defi.tags.3': '跨链桥',
  'productsDetail.defi.stats.0.label': '平台锁仓总价值 TVL',
  'productsDetail.defi.stats.1.label': '最高年化收益率',
  'productsDetail.defi.stats.2.unit': '协议',
  'productsDetail.defi.stats.2.label': '已部署 DeFi 协议数',
  'productsDetail.defi.stats.3.unit': '对',
  'productsDetail.defi.stats.3.label': '支持交易对数量',
  'productsDetail.defi.tabs.protocol': '质押协议',
  'productsDetail.defi.tabs.liquidity': '流动性挖矿',
  'productsDetail.defi.tabs.aggregator': '收益聚合',
  'productsDetail.defi.tabs.bridge': '跨链桥',
  'productsDetail.defi.tabs.governance': '治理投票',
  'productsDetail.mining.breadcrumb': '云矿机',
  'productsDetail.mining.title': '云矿机平台',
  'productsDetail.mining.highlight': '算力即服务，随时挖矿',
  'productsDetail.mining.cta': '获取云矿机方案',
  'productsDetail.mining.desc1': '提供 BTC/ETH/LTC 等主流币种云算力租赁平台一站式搭建，',
  'productsDetail.mining.desc2': '覆盖算力套餐管理、矿池接入、收益自动结算与机房托管系统，',
  'productsDetail.mining.desc3': '让任何人都能轻松参与加密货币挖矿。',
  'productsDetail.mining.tags.0': '算力租赁',
  'productsDetail.mining.tags.1': '矿池系统',
  'productsDetail.mining.tags.2': '自动结算',
  'productsDetail.mining.tags.3': '机房托管',
  'productsDetail.mining.stats.0.label': '平台总算力规模',
  'productsDetail.mining.stats.1.label': '矿机在线率保障',
  'productsDetail.mining.stats.2.unit': '大',
  'productsDetail.mining.stats.2.label': '全球机房节点',
  'productsDetail.mining.stats.3.label': '超低能耗比',
  'productsDetail.mining.tabs.hashrate': '算力套餐',
  'productsDetail.mining.tabs.infrastructure': '机房基础设施',
  'productsDetail.mining.tabs.pool': '矿池系统',
  'productsDetail.mining.tabs.earnings': '收益结算',
  'productsDetail.mining.tabs.colocation': '托管方案',
  'productsCta.back': '返回产品总览',
  'productsCta.cex.tag': 'Ready to Launch?',
  'productsCta.cex.title': '准备好启动您的交易所了吗？',
  'productsCta.cex.desc1': '从需求沟通到交付上线，我们的专业团队全程陪同，',
  'productsCta.cex.desc2': '最快 4 周完成标准版部署，附赠完整源码与运维手册。',
  'productsCta.cex.quote': '获取完整方案报价',
  'productsCta.cex.badge.0': '源码完整交付',
  'productsCta.cex.badge.1': '安全审计通过',
  'productsCta.cex.badge.2': '7×24 技术支持',
  'productsCta.cex.badge.3': '合规文件齐全',
  'productsCta.rwa.tag': 'Ready to Tokenize?',
  'productsCta.rwa.title': '准备好代币化您的资产了吗？',
  'productsCta.rwa.desc1': '从法律架构设计到智能合约部署，再到二级市场上架，',
  'productsCta.rwa.desc2': '我们的专业团队全程陪同，10-18 周完成完整发行流程。',
  'productsCta.rwa.quote': '获取 RWA 方案报价',
  'productsCta.rwa.badge.0': '合规资质认证',
  'productsCta.rwa.badge.1': '智能合约审计',
  'productsCta.rwa.badge.2': '15+ 司法辖区',
  'productsCta.rwa.badge.3': '法律文件齐全',
  'productsCta.wallet.tag': 'Launch Your Wallet',
  'productsCta.wallet.title': '打造专属的 Web3 钱包品牌',
  'productsCta.wallet.desc1': '从白标 SDK 集成到完整定制开发，最快 2 周完成品牌化钱包上线，',
  'productsCta.wallet.desc2': '完整源码交付，App Store 上架辅助。',
  'productsCta.wallet.quote': '获取钱包方案报价',
  'productsCta.wallet.badge.0': '100+ 公链支持',
  'productsCta.wallet.badge.1': '顶级安全审计',
  'productsCta.wallet.badge.2': '完整 SDK 交付',
  'productsCta.wallet.badge.3': '500+ DApp 生态',
  'productsCta.defi.tag': 'Launch Your DeFi Protocol',
  'productsCta.defi.title': '构建您的 DeFi 收益生态',
  'productsCta.defi.desc1': '从质押协议、AMM 流动性到跨链桥与 DAO 治理，',
  'productsCta.defi.desc2': '我们提供经过安全审计的完整 DeFi 协议栈，助您快速搭建并运营高 TVL 平台。',
  'productsCta.defi.quote': '获取 DeFi 方案报价',
  'productsCta.defi.badge.0': '智能合约三方审计',
  'productsCta.defi.badge.1': '四种质押模式',
  'productsCta.defi.badge.2': '40+ 链跨链桥',
  'productsCta.defi.badge.3': 'DAO 治理投票',
  'productsCta.mining.tag': 'Start Mining Today',
  'productsCta.mining.title': '搭建您的云矿机平台',
  'productsCta.mining.desc1': '从算力套餐到矿池系统，从机房基础设施到收益结算，',
  'productsCta.mining.desc2': '我们提供完整的云矿机平台一站式解决方案，',
  'productsCta.mining.desc3': '支持白标品牌定制，最快 6 周完成上线。',
  'productsCta.mining.quote': '获取云矿机方案报价',
  'productsCta.mining.badge.0': '100 EH/s+ 算力',
  'productsCta.mining.badge.1': '全球 5 大机房',
  'productsCta.mining.badge.2': '100% 清洁能源',
  'productsCta.mining.badge.3': '每日自动结算',
  'breadcrumb.advantages': '核心优势',
  'advantages.hero.tag': 'Core Advantages',
  'advantages.hero.title': '核心优势',
  'advantages.hero.highlight': '为什么选择我们',
  'advantages.hero.desc1': '8 年+行业积淀，五大核心优势构成难以复制的技术与服务壁垒，',
  'advantages.hero.desc2': '护航您的 Web3 业务从启动到规模化全程无忧。',
  'advantages.hero.pill.0': '模块化架构',
  'advantages.hero.pill.1': '公链生态',
  'advantages.hero.pill.2': '创新驱动',
  'advantages.hero.pill.3': '安全合规',
  'advantages.hero.pill.4': '客户导向',
  'advantages.s1.tag1': '模块化架构',
  'advantages.s1.title1': '高度模块化，',
  'advantages.s1.title1h': '灵活组合扩展',
  'advantages.s1.desc1': '我们的全栈解决方案基于微服务 + 模块化架构设计，各功能模块独立封装、自由组合。',
  'advantages.s1.desc2': '无论您需要一套完整的 CEX 系统，还是只需要特定的撮合引擎或 KYC 模块，都可以按需选配，',
  'advantages.s1.desc3': '大幅降低初期投入成本，并在业务增长时无缝扩展。',
  'advantages.s1.p1.0': '各功能模块独立部署，单模块故障不影响整体',
  'advantages.s1.p1.1': '按需组合：可单独采购 CEX 引擎或完整套件',
  'advantages.s1.p1.2': '支持热更新与灰度发布，业务零中断升级',
  'advantages.s1.p1.3': '标准化 API 接口，轻松对接第三方系统',
  'advantages.s1.p1.4': '微服务架构，水平扩展轻松应对业务爆发',
  'advantages.s1.stat1': '模块复用率',
  'advantages.s1.stat2': '迭代速度提升',
  'advantages.s1.stat3': '运维成本降低',
  'advantages.s1.badge1': '模块化架构',
  'advantages.s1.badge1d': '按需组装 · 独立部署',
  'advantages.s1.badge2': '多链互操作',
  'advantages.s1.badge2d': '15+ 主流公链支持',
  'advantages.s1.tag2': '完整公链生态布局',
  'advantages.s1.title2': '多链并行，',
  'advantages.s1.title2h': '全生态覆盖',
  'advantages.s1.desc4': '我们深度支持 15+ 主流公链，具备完整的跨链互操作能力。',
  'advantages.s1.desc5': '无论您的业务运行在以太坊的 DeFi 生态，还是 Solana 的高频交易场景，',
  'advantages.s1.desc6': '抑或波场的稳定币支付场景，我们都有成熟的解决方案和实战案例支撑。',
  'advantages.s1.p2.0': 'ETH、BSC、Solana、波场等主流公链深度支持',
  'advantages.s1.p2.1': '跨链桥接协议，实现多链资产无缝互通',
  'advantages.s1.p2.2': 'Layer 2 集成（Arbitrum、Optimism、ZK-Rollup）',
  'advantages.s1.p2.3': '联盟链+公链混合架构，兼顾合规与去中心化',
  'advantages.s1.p2.4': '多链钱包统一管理，降低用户操作门槛',
  'advantages.s2.tag1': '创新驱动',
  'advantages.s2.title1': '技术前沿，',
  'advantages.s2.title1h': '持续创新领跑',
  'advantages.s2.desc1': '我们保持对 Web3 前沿技术的持续追踪与研究投入，将 ZK Proof、Layer2、AI 风控等创新能力',
  'advantages.s2.desc2': '系统性融入产品体系，确保客户使用的技术始终处于行业领先水平，而非追赶者的角色。',
  'advantages.s2.inno.0.t': 'ZK Proof 应用',
  'advantages.s2.inno.0.d': '零知识证明技术，在保护用户隐私的同时实现合规验证，兼顾安全与体验。',
  'advantages.s2.inno.1.t': 'Layer 2 优化',
  'advantages.s2.inno.1.d': '深度集成 Arbitrum、Optimism、ZK-Rollup，Gas 成本降低 90%+，TPS 大幅提升。',
  'advantages.s2.inno.2.t': 'AI 智能风控',
  'advantages.s2.inno.2.d': '将机器学习模型嵌入风控引擎，实时识别异常交易行为，误报率低于 0.1%。',
  'advantages.s2.inno.3.t': 'NFT 基础设施',
  'advantages.s2.inno.3.d': '完整的 NFT 铸造、交易、碎片化和质押系统，支持 ERC-721/1155 等标准。',
  'advantages.s2.rd': '研发投入',
  'advantages.s2.rd1': '年收入投入研发',
  'advantages.s2.rd2': '核心技术专利',
  'advantages.s2.rd3': '技术工程师',
  'advantages.s2.badge': '多重安全保障',
  'advantages.s2.badged': '零致命漏洞上线承诺',
  'advantages.s2.tag2': '安全合规',
  'advantages.s2.title2': '安全第一，',
  'advantages.s2.title2h': '全球合规覆盖',
  'advantages.s2.desc3': '区块链行业安全事故频发，合规要求日趋严格。我们建立了业内领先的多层安全审计体系，',
  'advantages.s2.desc4': '同时深度研究全球主要司法辖区的合规框架，帮助客户在安全合规的轨道上稳健经营。',
  'advantages.s2.compTitle': '覆盖司法辖区',
  'advantages.s2.comp.0.r': '新加坡',
  'advantages.s2.comp.0.d': '支付服务法案 (PSA) 合规框架，数字支付代币服务牌照辅导',
  'advantages.s2.comp.1.r': '香港',
  'advantages.s2.comp.1.d': '虚拟资产服务提供商 (VASP) 牌照框架，证券型代币合规发行',
  'advantages.s2.comp.2.r': '欧盟',
  'advantages.s2.comp.2.d': 'Markets in Crypto-Assets 法规合规评估与系统适配',
  'advantages.s2.comp.3.r': '美国',
  'advantages.s2.comp.3.d': 'AML/KYC 反洗钱合规体系搭建，MSB 牌照申请支持',
  'advantages.s2.comp.4.r': '开曼群岛',
  'advantages.s2.comp.4.d': '离岸基金与 DeFi 协议的合规架构设计',
  'advantages.s2.comp.5.r': '英属维京岛',
  'advantages.s2.comp.5.d': 'Web3 项目离岸公司注册与合规运营支持',
  'advantages.s3.tag': '客户导向与生态共赢',
  'advantages.s3.title1': '以客户成功为',
  'advantages.s3.title2': '唯一目标',
  'advantages.s3.desc1': '我们不只是技术供应商，而是您的长期战略技术合伙人。',
  'advantages.s3.desc2': '每一个合作客户的成功，都是我们最有价值的品牌证明。',
  'advantages.s3.benefit.0.title': '专属项目经理',
  'advantages.s3.benefit.0.desc': '每个项目配备 1 名专属 PM，全程跟进需求、进度、上线，统一沟通窗口，高效决策。',
  'advantages.s3.benefit.1.title': '30 分钟响应承诺',
  'advantages.s3.benefit.1.desc': '关键系统问题 30 分钟内响应，生产故障 2 小时内修复，SLA 写入合同有法律约束力。',
  'advantages.s3.benefit.2.title': '生态资源对接',
  'advantages.s3.benefit.2.desc': '为客户引荐律所、做市商、交易所、媒体资源，帮助业务快速获取生态合作机会。',
  'advantages.s3.benefit.3.title': '以客户成功为目标',
  'advantages.s3.benefit.3.desc': '我们的成功与客户业务成功深度绑定。客户成功案例，才是我们最有价值的品牌资产。',
  'advantages.s3.compareTitle': '与行业同类对比',
  'advantages.s3.compareCol.0': '能力对比',
  'advantages.s3.compareCol.1': '我们',
  'advantages.s3.compareCol.2': '一般供应商',
  'advantages.s3.compare.0': '模块化架构',
  'advantages.s3.compare.1': '15+ 公链支持',
  'advantages.s3.compare.2': 'ZK/Layer2 集成',
  'advantages.s3.compare.3': '全球合规覆盖',
  'advantages.s3.compare.4': '专属项目经理',
  'advantages.s3.compare.5': '源码完整交付',
  'advantages.s3.compare.6': '24/7 技术支持',
  'advantages.s3.compare.7': '生态资源对接',
  'advantages.s3.cta.title': '准备好了吗？',
  'advantages.s3.cta.desc': '我们是您 Web3 业务最可靠的技术伙伴',
  'advantages.s3.cta.btn2': '浏览产品体系',
  'aboutPage.mission.badge': '新加坡注册成立',
  'aboutPage.mission.cardTitle': '我们的使命',
  'aboutPage.mission.cardDesc1': '将复杂的区块链技术转化为企业可落地的生产力，',
  'aboutPage.mission.cardDesc2': '让 Web3 真正服务于实体经济发展。',
  'aboutPage.mission.tag': '起源与使命',
  'aboutPage.mission.title1': '诞生于',
  'aboutPage.mission.title2': '区块链黎明',
  'aboutPage.mission.p1': '2023 年，创始团队在新加坡注册成立公司，彼时区块链技术刚刚萌芽。我们坚信，这项技术将彻底重塑全球金融体系与实体经济的运作方式。',
  'aboutPage.mission.p2': '我们见证了从比特币到以太坊智能合约，从 DeFi 到 NFT，再到 RWA 资产代币化的完整演进周期。每一个技术浪潮，我们都深入其中，积累了无可替代的实战经验。',
  'aboutPage.mission.p3.prefix': '我们的使命始终如一：',
  'aboutPage.mission.p3.strong': '将复杂的区块链技术转化为企业可落地的生产力',
  'aboutPage.mission.p3.suffix': '，让每一家有志于 Web3 转型的企业都能获得专业、高效、安全的技术支撑。',
  'aboutPage.mission.timeline.0.year': '2023',
  'aboutPage.mission.timeline.0.event': '创始团队进军区块链领域，潜心研究相关工作',
  'aboutPage.mission.timeline.1.year': '2024',
  'aboutPage.mission.timeline.1.event': '推出首个 CEX 全栈解决方案',
  'aboutPage.mission.timeline.2.year': '2025',
  'aboutPage.mission.timeline.2.event': 'DeFi 浪潮中全面布局 DApp、钱包与 IM 产品线',
  'aboutPage.mission.timeline.3.year': '2025',
  'aboutPage.mission.timeline.3.event': 'RWA 解决方案正式发布，开拓实物资产代币化赛道，并在新加坡注册成立公司',
  'aboutPage.mission.timeline.4.year': '2026',
  'aboutPage.mission.timeline.4.event': '服务全球企业客户，成为 Web3 全栈标杆服务商',
  'aboutPage.values.tag': '核心价值与差异化',
  'aboutPage.values.title': '我们的核心价值观',
  'aboutPage.values.subtitle': '八年专注，三大价值观贯穿我们的每一个产品决策与服务行为',
  'aboutPage.values.v0.title': '技术即服务',
  'aboutPage.values.v0.subtitle': 'Technology as a Service',
  'aboutPage.values.v0.desc': '我们不只是外包供应商，而是客户真正的技术合伙人。从战略规划到落地实施，全程深度参与，以客户业务成功为唯一目标。',
  'aboutPage.values.v0.f0': '专属技术顾问',
  'aboutPage.values.v0.f1': '深度业务理解',
  'aboutPage.values.v0.f2': '长期合作伙伴',
  'aboutPage.values.v1.title': '产业 + Web3 融合',
  'aboutPage.values.v1.subtitle': 'Industry × Web3 Integration',
  'aboutPage.values.v1.desc': '我们专注于将传统产业与 Web3 深度结合，而非纯粹的加密概念炒作。每一个解决方案都以真实业务场景为出发点，确保技术创造实际价值。',
  'aboutPage.values.v1.f0': '实物资产代币化',
  'aboutPage.values.v1.f1': '供应链金融上链',
  'aboutPage.values.v1.f2': '合规数字资产发行',
  'aboutPage.values.v2.title': '全生命周期支持',
  'aboutPage.values.v2.subtitle': 'Full Lifecycle Support',
  'aboutPage.values.v2.desc': '从战略咨询、架构设计、系统开发、部署上线，到持续运维与迭代升级，我们提供端到端的全链路支持，确保客户零后顾之忧。',
  'aboutPage.values.v2.f0': '咨询 → 开发 → 运维',
  'aboutPage.values.v2.f1': '源码完整交付',
  'aboutPage.values.v2.f2': '售后保障体系',
  'aboutPage.values.diffTitle': '与众不同之处',
  'aboutPage.values.d0.title': '全栈产品矩阵',
  'aboutPage.values.d0.desc': 'CEX + RWA + 钱包 + DApp，任何 Web3 业务场景都有完整产品支撑',
  'aboutPage.values.d1.title': '多司法辖区合规',
  'aboutPage.values.d1.desc': '深度理解新加坡 MAS、香港 SFC 等主流合规框架，确保合法合规运营',
  'aboutPage.values.d2.title': '模块化灵活组合',
  'aboutPage.values.d2.desc': '各产品模块独立部署、自由组合，按需定制，快速响应业务变化',
  'aboutPage.values.d3.title': '24/7 专属支持',
  'aboutPage.values.d3.desc': '专属项目经理 + 全天候技术团队，任何问题 30 分钟内响应',
  'aboutPage.commit.tag': '承诺与保障',
  'aboutPage.commit.title': '我们的服务承诺',
  'aboutPage.commit.subtitle': '言出必行，每一条承诺都写入合同，以法律约束力保障您的权益',
  'aboutPage.commit.c0.title': '源码完整交付',
  'aboutPage.commit.c0.desc': '所有定制开发项目均提供完整源码，客户完全掌控技术资产，无任何锁定风险。',
  'aboutPage.commit.c1.title': '多重安全审计',
  'aboutPage.commit.c1.desc': '专业安全团队全程介入，代码审计、漏洞扫描、渗透测试，确保系统零致命漏洞上线。',
  'aboutPage.commit.c2.title': '专属项目经理',
  'aboutPage.commit.c2.desc': '每个项目配备专属 PM，全程跟进需求、进度、质量，您只需要做决策，我们负责执行。',
  'aboutPage.commit.c3.title': '24/7 技术支持',
  'aboutPage.commit.c3.desc': '技术团队全天候待命，关键问题 30 分钟响应，确保您的业务永不中断。',
  'aboutPage.commit.c4.title': '发票合规开具',
  'aboutPage.commit.c4.desc': '新加坡注册企业，可按需开具合规发票，支持多种付款方式，满足不同企业财务需求。',
  'aboutPage.commit.c5.title': '持续迭代升级',
  'aboutPage.commit.c5.desc': '项目交付不是终点。我们提供长期维护合约，随业务发展持续升级迭代，保持系统长期竞争力。',
  'aboutPage.future.tag': '展望未来',
  'aboutPage.future.title1': '成为全球领先的',
  'aboutPage.future.title2': '产业区块链服务商',
  'aboutPage.future.desc1': '未来五年，我们将持续深耕 RWA 实物资产代币化赛道，推动更多传统产业完成 Web3 转型。',
  'aboutPage.future.desc2': '在全球合规化浪潮中，帮助客户抢占先机，共同构建更公平、更透明、更高效的数字经济基础设施。',
  'aboutPage.future.btn1': '立即开始合作',
  'aboutPage.future.btn2': '查看核心优势',

  'seo.brand': 'GEEL TEC',
  'seo.home.title': '产业区块链与 Web3 全栈解决方案 | GEEL TEC',
  'seo.home.desc':
    '新加坡总部，提供 CEX、RWA、数字钱包与 DApp 定制等企业级区块链与 Web3 解决方案。',
  'seo.home.keywords':
    'GEEL TEC, 产业区块链, Web3, 企业数字化转型, 区块链解决方案, 新加坡, CEX, RWA, 数字钱包, DApp, 智能合约',
  'seo.about.title': '公司简介',
  'seo.about.desc':
    '总部位于新加坡的产业区块链与 Web3 科技公司，专注全栈解决方案、合规咨询与全球交付。',
  'seo.about.keywords': 'GEEL TEC, 公司简介, 新加坡公司, 区块链公司, Web3 咨询, 合规, 企业区块链',
  'seo.advantages.title': '核心优势',
  'seo.advantages.desc': '模块化架构、多链生态、安全合规与 24/7 支持，助力企业稳妥落地 Web3 业务。',
  'seo.advantages.keywords': 'GEEL TEC, 核心优势, 模块化架构, 多链, 安全合规, 7x24 支持, Web3 落地',
  'seo.products.title': '产品体系',
  'seo.products.desc': 'CEX、RWA、钱包、DeFi/DApp 与挖矿等模块化产品，可按需组合、快速上线。',
  'seo.products.keywords': 'GEEL TEC, 产品体系, CEX, RWA, 钱包, DeFi, DApp, 挖矿, 区块链产品',
  'seo.products.cex.title': '中心化交易所 CEX',
  'seo.products.cex.desc': '高性能撮合、KYC/AML、多端交易所系统开发与运维一体化方案。',
  'seo.products.cex.keywords': 'GEEL TEC, CEX, 中心化交易所, 撮合引擎, KYC, AML, 交易所开发',
  'seo.products.rwa.title': 'RWA 解决方案',
  'seo.products.rwa.desc': '实物资产代币化、合规确权与链上分红，连接传统金融与链上流动性。',
  'seo.products.rwa.keywords': 'GEEL TEC, RWA, 实物资产代币化, 资产上链, 合规代币化, 数字资产',
  'seo.products.wallet.title': '钱包类产品',
  'seo.products.wallet.desc': '多链钱包、DApp 浏览器与社交能力，支持企业白标与深度定制。',
  'seo.products.wallet.keywords': 'GEEL TEC, 数字钱包, 多链钱包, DApp 浏览器, 白标钱包, Web3 钱包',
  'seo.products.defi.title': 'DeFi 与质押',
  'seo.products.defi.desc': '质押、流动性挖矿与链上激励等 DeFi 模块，安全可审计、可弹性扩展。',
  'seo.products.defi.keywords': 'GEEL TEC, DeFi, 质押, 流动性挖矿, 链上激励, 智能合约, DApp 开发',
  'seo.products.mining.title': '挖矿类产品',
  'seo.products.mining.desc': '矿池、算力与收益体系相关技术方案，面向机构与企业级部署。',
  'seo.products.mining.keywords': 'GEEL TEC, 挖矿, 矿池, 算力, 机构挖矿, 区块链基础设施',
  'seo.news.title': '新闻动态',
  'seo.news.desc': '产品更新、行业洞察与活动资讯，了解 GEEL TEC 在区块链领域的最新进展。',
  'seo.news.keywords': 'GEEL TEC, 新闻, 区块链资讯, Web3 动态, 产品更新, 行业洞察',
  'seo.newsDetail.title': '新闻详情',
  'seo.newsDetail.desc': '阅读 GEEL TEC 新闻与深度文章，获取 Web3 与企业区块链实践洞察。',
  'seo.newsDetail.keywords': 'GEEL TEC, 新闻详情, 区块链文章, Web3, 深度稿',
  'seo.contact.title': '联系我们',
  'seo.contact.desc': '业务咨询、技术合作与合规路径沟通，联系 GEEL TEC 专业团队获取方案建议。',
  'seo.contact.keywords': 'GEEL TEC, 联系我们, 商务咨询, 技术支持, 合规咨询, Web3 合作',
  'seo.notFound.title': '页面未找到',
  'seo.notFound.desc': '您访问的页面不存在或已移动，请返回首页或通过导航继续浏览。',
  'seo.notFound.keywords': 'GEEL TEC, 404, 页面未找到',
};
